import { motion } from 'framer-motion';

const footerLinks = {
  solutions: [
    { label: 'AI Intake Systems', href: '#solutions' },
    { label: 'Workflow Automation', href: '#solutions' },
    { label: 'Communication Automation', href: '#solutions' },
    { label: 'Supervisory Control', href: '#solutions' },
  ],
  industries: [
    { label: 'Recruitment', href: '#industries' },
    { label: 'Logistics', href: '#industries' },
    { label: 'Operations', href: '#industries' },
  ],
  company: [
    { label: 'Use Cases', href: '#use-cases' },
    { label: 'Process', href: '#process' },
    { label: 'Contact', href: '#contact' },
  ],
};

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-slate-950 py-16 md:py-20 border-t border-slate-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {/* Main Footer Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-14">
            {/* Brand Column */}
            <div className="col-span-2 md:col-span-1">
              <h3 className="text-lg font-bold text-white font-['Manrope'] mb-4">
                Pyrtex
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
                Structured AI automation for operations-driven companies.
              </p>
            </div>

            {/* Solutions Column */}
            <div>
              <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-5">
                Solutions
              </h4>
              <ul className="space-y-3">
                {footerLinks.solutions.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-slate-500 hover:text-white transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Industries Column */}
            <div>
              <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-5">
                Industries
              </h4>
              <ul className="space-y-3">
                {footerLinks.industries.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-slate-500 hover:text-white transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Column */}
            <div>
              <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-5">
                Company
              </h4>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-sm text-slate-500 hover:text-white transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-slate-800/50">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-sm text-slate-600">
                © {currentYear} Pyrtex
              </p>
              <p className="text-sm text-slate-600">
                pyrtex.com
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
